<!--
 * @Descripttion: 带form表单的抽屉模板
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 21:00:27
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-26 11:18:28
-->
<template>
	<div>
		<el-drawer
			title="集合页配置"
			:visible.sync="visible"
			:append-to-body="appendToBody"
			:size="size"
			:before-close="handleClose"
			:wrapperClosable="wrapperClosable"
			custom-class="drawer-template"
		>
			<div class="content">
				<!-- 弹窗内容部分 -->
				<el-form :model="formData" :rules="rules" ref="form" :label-width="labelWidth">
					<el-form-item label="集合页名称" prop="title">
						<el-input v-model="formData.title" placeholder="请输入最多10字" maxlength="10" show-word-limit />
					</el-form-item>
					<el-form-item label="banner图" prop="img">
						<div class="flex flex-align-end">
							<uploadImg
								:key="visible"
								@saveCardLink="saveCardLink"
								:limitSize="2"
								:default_img="formData.imageUrl"
								:widthAndHeight="[1125, '0~3462']"
								ref="uploadImg"
								class="upload-img"
							></uploadImg>
							<p class="yx-color-blue-6 ml-10  font-h6-regular">请上传JPG/PNG/GIF 格式的图片，尺寸：宽 1125 * 高(0～3462) ，大小不超过2M</p>
						</div>
					</el-form-item>
					<el-form-item label="关联商品组" prop="type">
						<div class="flex">
							<el-button type="primary" @click="addGoodsGroup" plain>选择商品组</el-button>
							<p class="flex flex-align-center ml-16" v-if="formData.link">
								<el-tooltip placement="top" :content="formData.groupTitle" v-ak-tooltip-auto-show>
									<span class="line-ellipsis-1 yx-color-pure-1 font-h4-regular" style="max-width: 360px;">已选：{{ formData.groupTitle }}</span>
								</el-tooltip>
							</p>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div class="drawer-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="confirm" :loading="loading" :disabled="!isDisable">确认</el-button>
			</div>
		</el-drawer>
		<selectGroupGrawer ref="selectGroupGrawer" :platformId="platformId" :size="groupSize" @confirmAddGoodsGroup="confirmAddGoodsGroup" />
	</div>
</template>
<script>
import uploadImg from '@/components/common/uploadImg';
import selectGroupGrawer from '../selectGroupGrawer';
import { addGatherPage, updateGatherPage } from '@/api/selectionDecoration';
export default {
	components: {
		selectGroupGrawer,
		uploadImg,
	},
	props: {
		size: {
			type: Number,
			default: 800,
		},
		platformId: {
			type: [String, Number],
			default: 1,
		},
	},
	computed: {
		groupSize({ size }) {
			const obj = {
				800: 700,
				640: 520,
			};
			return obj[size];
		},
		isDisable({ formData }) {
			return formData.title;
		},
	},
	data() {
		return {
			title: '集合页配置', // 弹窗标题
			visible: false, // 弹窗显隐
			formData: {
				title: '',
				imageUrl: '',
				link: '',
				groupTitle: '',
			}, // 表单数据
			rules: {
				title: [{ required: true, message: '测试表单不可为空', trigger: 'blur' }],
			},
			loading: false, // 按钮loading状态
			editType: 'add', //add新增 edit编辑
		};
	},
	created() {
		this.initData();
	},
	mounted() {},
	methods: {
		// 主动显示弹窗
		show(type, val = {}) {
			if (val.link) {
				this.editType = 'edit';
				Object.keys(val).forEach(key => (this.formData[key] = val[key]));
			}
			this.visible = true;
		},
		addGoodsGroup() {
			this.$refs.selectGroupGrawer.show(this.formData.link);
		},
		confirmAddGoodsGroup(val) {
			Object.keys(val).forEach(key => (this.formData[key] = val[key]));
		},
		// 清空数据并关闭弹窗
		handleClose() {
			this.$refs.uploadImg.clearFiles();
			this.formData = {
				title: '',
				imageUrl: '',
				link: '',
				groupTitle: '',
			};
			this.editType = 'add';
			// 关闭弹窗
			this.visible = false;
		},
		// 确认按钮点击事件
		async confirm() {
			const { platformId, formData, editType } = this;
			const api = {
				add: addGatherPage,
				edit: updateGatherPage,
			};
			try {
				await api[editType]({ ...formData, platformId });
				this.$message.success('添加成功');
				// 按钮loading开启
				this.loading = false;
				// 刷新列表（外部重新获取数据）
				this.$emit('refresh');
				// 完成之后清空数据
				this.handleClose();
			} finally {
				this.loading = false;
			}
		},
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 表单项标签宽度
			this.labelWidth = '100px';
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 点击蒙版是否关闭
			this.wrapperClosable = false;
		},
		createCollection() {},
		saveCardLink(val) {
			this.formData.imageUrl = val;
		},
	},
	beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.content {
	.disable-style {
		color: #c9cdd4;
	}
	::v-deep .el-form-item {
		margin-bottom: 24px;
	}
	::v-deep .el-radio__label {
		color: #4e596a;
	}
	.upload-img {
		/deep/ .el-upload--picture-card {
			background-color: #fff;
			width: 60px;
			height: 60px;
		}
		/deep/ .el-upload-list--picture-card .el-upload-list__item {
			width: 60px;
			height: 60px;
		}
		/deep/ .el-upload--picture-card i {
			font-size: 16px;
			color: #86909d;
		}
	}
}
</style>
